export default "__VITE_ASSET__DOERAKme__"